export const cpfMask = (val) => {
	//pegar valor puro (sem traços, espaços e pontos, nesse caso, só digitos de 0 a 9)
	val = val.replace(/[^0-9]+/g, "");

	//cpf tem 11 digitos
	if (val.length > 11) val = val.slice(0, 11);

	//função pra formatar
	const valSplit = val.split("");
	let returnValue = "";
	for (let index = 1; index < valSplit.length + 1; index++) {
		const val = valSplit[index - 1];
		if (index > 11) {
			return returnValue;
		}

		if (index === 10) {
			returnValue += "-" + val;
		} else if (index > 1 && (index - 1) % 3 === 0) {
			returnValue += "." + val;
		} else {
			returnValue += val;
		}
	}
	return returnValue;

}

export const cnpjMask = (val) => {
	// Remove tudo que não seja número
	val = val.replace(/[^0-9]+/g, "");

	if (val.length > 14) val = val.slice(0, 14);

	const valSplit = val.split("");
	let returnValue = "";

	for (let i = 0; i < valSplit.length; i++) {
		const char = valSplit[i];

		if (i === 2 || i === 5) {
			returnValue += ".";
		} else if (i === 8) {
			returnValue += "/";
		} else if (i === 12) {
			returnValue += "-";
		}

		returnValue += char;
	}

	return returnValue;
};

export const letraMask = (val) => {
	// Remover tudo que não seja letra ou espaço
	val = val.replace(/[^A-Za-zá-úÁ-Ú\s]+/g, "");

	return val;
}

export const numberMask = (val) => {
	// Remover tudo que não seja número
	val = val.replace(/[^0-9]+/g, "");

	return val;
}

export const cellMask = (value) => {
	// Remover tudo que não seja número
	value = value.replace(/\D/g, "");

	// Aplicar a máscara
	if(value.length >= 8){
		return `(${value.slice(0,2)}) ${value.slice(2,7)}-${value.slice(7,11)}`;
	}
	else if (value.length >=3){
		return `(${value.slice(0,2)}) ${value.slice(2,11)}`;
	}else{
		return value.slice(0,11)
	}
	
};


export const phoneMask = (value) => {
	// Remover tudo que não seja número
	value = value.replace(/\D/g, "");

	// Aplicar a máscara
	if(value.length >= 7){
		return `(${value.slice(0,2)}) ${value.slice(2,6)}-${value.slice(6,10)}`;
	}
	else if (value.length >=3){
		return `(${value.slice(0,2)}) ${value.slice(2,10)}`;
	}else{
		return value.slice(0,10)
	}
	
};



export const cepMask = (value) => {
	// Remove tudo o que não for número
	value = value.replace(/\D/g, "");

	// Aplica a máscara no formato XXXXX-XXX
	if (value.length <= 5) {
		return value;
	} else {
		return `${value.slice(0, 5)}-${value.slice(5, 8)}`;
	}
};

export const rgMask = (val) => {
	val = val.replace(/[^0-9]+/g, "");

	if (val.length > 9) val = val.slice(0, 9);

	const valSplit = val.split("");
	let returnValue = "";

	for (let index = 1; index <= valSplit.length; index++) {
		const digit = valSplit[index - 1];

		if (index > 9) {
			return returnValue;
		}

		if (index === 3 || index === 6) {
			returnValue += "." + digit;
		}
		else if (index === 9) {
			returnValue += "-" + digit;
		}
		else {
			returnValue += digit;
		}
	}

	return returnValue;
}
